import { createAsyncThunk } from "@reduxjs/toolkit";
import { mapBuildingControlProjectsTypes } from "../Types/BuildingControl/BuildingControlProjectsType";
import {
    getAllBuildingControlProjects,
    getBuildingControlPermissions,
    getBuildingControlQuotationRequests,
    getBuildingControlQuotations,
    getBuildingInspectionCompanies,
} from "../../Api/BuildingControlService/BuildingControlService";
import { mapBuildingControlQuotationRequests, mapBuildingControlQuotations, mapBuildingInspectionCompanies } from "../Types/BuildingControl/BuildingControlQuotationType";
import { mapBuildingControlPermissions } from "../Types/BuildingControl/BuildingControlPermissionType";

// fetch all building control project list
export const fetchAllBuildingControlProjects = createAsyncThunk('fetchAllBuildingControlProjects', async (_, { rejectWithValue }) => {
    try {
        // api
        const response = await getAllBuildingControlProjects();
        if (response.status) {
            return mapBuildingControlProjectsTypes(response.body);
        } else {
            // If the API returns a failure status, return the error message
            return rejectWithValue(response.error);
        }
    } catch (error: any) {
        // Handle the case where the API call itself throws an error
        return rejectWithValue('Failed to fetch building control projects');
    }
});

// ---------------------------------------- Building control quotation
// fetch building inspection companies
export const fetchBuildingInspectionCompanies = createAsyncThunk(
    'fetchBuildingInspectionCompanies',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getBuildingInspectionCompanies();

            if (response.status) {
                return mapBuildingInspectionCompanies(response.body);
            } else {
                return rejectWithValue(response.error);
            }
        } catch (error: any) {
            return rejectWithValue('Failed to fetch building inspection companies');
        }
    }
);

// fetch building control quotations
export const fetchBuildingControlQuotations = createAsyncThunk(
    'fetchBuildingControlQuotations',
    async (role: 'architect' | 'client', { rejectWithValue }) => {
        try {
            const response = await getBuildingControlQuotations(role);

            if (response.status) {
                return mapBuildingControlQuotations(response.body);
            } else {
                return rejectWithValue(response.error);
            }
        } catch (error: any) {
            return rejectWithValue('Failed to fetch building control quotations');
        }
    }
);

// fetch building control quotation requests
export const fetchBuildingControlQuotationRequests = createAsyncThunk(
    'fetchBuildingControlQuotationRequests',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getBuildingControlQuotationRequests();

            if (response.status) {
                return mapBuildingControlQuotationRequests(response.body);
            } else {
                return rejectWithValue(response.error);
            }
        } catch (error: any) {
            return rejectWithValue('Failed to fetch building control quotation requests');
        }
    }
);


// ---------------------------------------- Building control permissions
// fetch building control permissions
export const fetchBuildingControlPermissions = createAsyncThunk(
    'fetchBuildingControlPermissions',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getBuildingControlPermissions();

            if (response.status) {
                return mapBuildingControlPermissions(response.body);
            } else {
                return rejectWithValue(response.error);
            }
        } catch (error: any) {
            return rejectWithValue('Failed to fetch building control permissions');
        }
    }
);
